module.exports = __webpack_public_path__ + "static/img/11.85c790c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/11.png
// module id = RKxq
// module chunks = 1